import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import AddVendorSubUsers from "components/common/AddVendorSubUsers";

// ✅ Updated Imports from vendor slice
import {
  vendorSubUserSelector,
  fetchVendorSubUsers,
  removeMultipleVendorSubUsers,
  changeVendorSubUserStatus,
} from "slices/vendorSubUserSlice";

const apiService = new Api();

function VendorSubUser() {
  const dispatch = useDispatch();
  const {
    vendorSubUsers,
    last_page: totalPages,
    loader,
    total,
    current_page,
    per_page: pageLength,
  } = useSelector(vendorSubUserSelector);

  console.log('DEBUG vendorSubUsers:', vendorSubUsers);
console.log('typeof vendorSubUsers:', typeof vendorSubUsers);
console.log('isArray vendorSubUsers:', Array.isArray(vendorSubUsers));

  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {},
  });

  const refAddButton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: "name",
    sortDirection: "asc",
  });

  React.useEffect(() => {
    dispatch(fetchVendorSubUsers());
  }, [dispatch]);

  const handleAddVendorPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, { className: "successToast" });
      setSelectedItems([]);
      setSelectAll(false);
      dispatch(fetchVendorSubUsers());
      hideConfirmDialog();
    } else {
      toast.error(message, { className: "errorToast" });
    }
  };

  const showConfirmDialog = () => setDeleteModal(true);
  const hideConfirmDialog = () => setDeleteModal(false);

  const handleRemoveItems = () => {
    dispatch(removeMultipleVendorSubUsers({ ids: selectedItems }, submitCallback));
  };

  const handleChange = (e) => {
    const id = e.target.dataset.value;
    setSelectedItems(
      selectedItems.includes(id)
        ? selectedItems.filter((item) => item !== id)
        : [...selectedItems, id]
    );
  };

  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectAll(false);
      return;
    }
    setSelectAll(true);
    setSelectedItems(vendorSubUsers?.map((val) => val.id.toString()));
  };

  const handlePageChange = React.useCallback(
    (page) => {
      setCurrentPage(page);
      dispatch(fetchVendorSubUsers(page));
    },
    [dispatch]
  );

  const handleClose = () => setAddForm({ show: false });

  const handleSelect = (value) => setSelectedValue(value);

  //#region TABLE HEADER
  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(
        fetchVendorSubUsers(currentPage, {
          sortBy,
          sortDirection: dir,
          search: searchTerm,
        })
      );
    };

    return (
      <tr>
        <th>
          <div className="row_check">
            <span>#</span>
            {/* <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                checked={selectAll}
                onChange={handleToggleSelectAll}
              />
              <span className="checkmark"></span>
            </label> */}
          </div>
        </th>

        <th>
          <TableHeaderItem
            title="Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Email"
            sortBy="email"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Created At"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {/* <th>
          <TableHeaderItem
            title="Status"
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th> */}

        {/* <th>Actions</th> */}
      </tr>
    );
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);
  //#endregion

  //#region TABLE BODY
  const renderTableContent = React.useCallback(() => {
    return vendorSubUsers?.map((item, index) => (
      <VendorSubUserItem
        key={item.id}
        data={item}
        index={index}
        selectedItems={selectedItems}
        handleChange={handleChange}
        handleAddPopUp={handleAddVendorPopUp}
        current_page={current_page}
        pageLength={pageLength}
      />
    ));
  }, [vendorSubUsers, selectedItems]);
  //#endregion

  return (
    <ListLayout
      heading="Vendor Sub Users"
      buttonTitle="Add Vendor Sub User"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchVendorSubUsers}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => (
        <AddVendorSubUsers
          item={addForm.item}
          show={addForm.show}
          onClose={handleClose}
          callback={callback}
        />
      )}
      refAddutton={refAddButton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddVendorPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      disableBootstrap
      addButtonDisabled={true}
      noOfItems={total}
      searchPlaceholder="Search vendor sub users ..."
    >
      {deleteModal && (
        <ConfirmationModal
          onClose={hideConfirmDialog}
          isOpen={deleteModal}
          onConfirm={handleRemoveItems}
        />
      )}
    </ListLayout>
  );
}

const VendorSubUserItem = ({
  data,
  index,
  selectedItems,
  handleChange,
  handleAddPopUp,
  current_page,
  pageLength,
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(data?.status === 1 ? 1 : 0);

  React.useEffect(() => {
    setStatus(data?.status === 1 ? 1 : 0);
  }, [data]);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0);
    dispatch(changeVendorSubUserStatus(id, { status: s ? 1 : 0 }));
  };

  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: "#f4f4f4" } : {};
  };

  console.log(current_page, ' current_page')
  console.log(pageLength, 'pageLength')

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength, index]);

  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {/* <label className="custom-checkbox checkbox">
            <input
              type="checkbox"
              data-value={data.id}
              checked={selectedItems.includes(data.id.toString())}
              onChange={handleChange}
            />
            <span className="checkmark"></span>
          </label> */}
        </div>
      </td>

      <td style={getBackgroundStyle(status)}>{data?.name}</td>
      <td style={getBackgroundStyle(status)}>{data?.email}</td>
      <td style={getBackgroundStyle(status)}>{data?.created_at}</td>
      {/* <td style={getBackgroundStyle(status)}>
        <CustomSwitch
            handleChange={(checked) => handleStatusChange(data?.id, checked)}
            checked={status === 1}
          />
      </td> */}

      {/* <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <button
            className="table_edit"
            onClick={() => handleAddPopUp({ ...data, status })}
          >
            Edit
          </button>
          
        </div>
      </td> */}
    </tr>
  );
};

export default VendorSubUser;
